import { BefWhereControls } from "@beflam/bef-core";

export const RPC_ASSEMBLY = "Beflam.Framework";
export const RPC_MODULE = "Beflam.Framework.Service.UserService";
export const PAGE_SIZE = 10;

export const COLUMNS = [
    { header: "应用编号", key: "AppId" },
    { header: "用户编号", key: "UserId" },
    { header: "用户名", key: "UserName" },
    { header: "性别", key: "Gender" },
    { header: "状态", key: "State" },
    { header: "默认语言", key: "Language" }
];

export const EXPORT_COLUMNS = [
    { header: "应用编号", key: "AppId" },
    { header: "用户编号", key: "UserId" },
    { header: "用户名", key: "UserName" },
    { header: "性别", key: "Gender" },
    { header: "状态", key: "State" },
    { header: "默认语言", key: "Language" }
];

export const CONVERT_FIELDS = {
    State: { "AC": "激活", "LC": "锁定", "DL": "删除", "RP": "重置" } as any,
    Gender: { 0: "女", 1: "男" },
    Language: { "zh-CN": "中文", "en-US": "英文" }
};

export const WHERES_ACTIVE: any[] = [{ field: 'State', control: 'notEqualTo', value: "DL" }];
export const WHERES_DELETED: any[] = [{ field: 'State', control: 'equalTo', value: "DL" }];

export const ACTIVE_USER_ACTIONS = [
    { id: 'edit', icon: '1:pencil', children: '编辑' },
    { id: 'delete', icon: '1:trash', children: '删除' },
    { id: 'detail', icon: '1:eye', children: '显示' },
    { id: 'permission', icon: '1:people', children: '权限配置' },
    { id: 'updatePassword', icon: '1:key', children: '重置密码' },
    { id: 'personate', icon: '1:people', children: '模拟登录' },
];

export const DELETED_USER_ACTIONS = [
    { id: 'detail', icon: '1:eye', children: '显示' },
    { id: 'back', icon: '1:arrowUndo', children: '恢复' },
    { id: 'realdelete', icon: '1:trash', children: '彻底删除' },
];

export function mergeWheresWithStateOverride(baseWheres: any[], filterWheres: any[]): any[] {
    let _wheres = [...baseWheres];
    let flag = false;
    if (filterWheres) {
        filterWheres.map((item: any) => {
            item.control = BefWhereControls[item.control];
            if (item.field === 'State')
                flag = true;
            return item;
        });
        if (!flag)
            _wheres = _wheres.concat(filterWheres);
        else
            _wheres = filterWheres;
    }
    return _wheres;
}

export function mergeWheresConcat(baseWheres: any[], filterWheres: any[]): any[] {
    return [...baseWheres].concat(filterWheres);
}

export const MERGE_WHERES_ACTIVE = mergeWheresWithStateOverride;
export const MERGE_WHERES_DELETED = mergeWheresConcat;
